<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="text-h5 warning--text">
        <v-icon color="warning" class="ml-2">mdi-alert</v-icon>
        تأكيد المعالجة
      </v-card-title>

      <v-card-text class="pt-4 text-center">
        <p class="text-h6">هل أنت متأكد؟</p>
        <p class="grey--text">
          {{ confirmMessage }}
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="handleCancel" :disabled="loading">
          إلغاء
        </v-btn>
        <v-btn color="primary" @click="handleConfirm" :loading="loading">
          نعم، تأكيد
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    confirmMessage: {
      type: String,
      default: "هل تريد تأكيد معالجة هذا الطلب؟",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    handleConfirm() {
      this.$emit("confirm");
    },

    handleCancel() {
      this.$emit("cancel");
      this.dialog = false;
    },
  },
};
</script>